import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import artajasa from './artajasa.png';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    clear: 'right'
  },
  image: {
    alignSelf: 'flex-end',
    width:'10%',
    height:'15%'
  },
  content: {
    textAlign: 'justify',
    lineHeight: '1.4',
    fontSize: 14
  }
});

const FormHeader = ({title, desc}) => (
  <View>
    <Image
      style={styles.image}
      src={artajasa}
    />
    <Text style={styles.title}>{title}</Text>
    <View style={{ marginTop: '30px' }}>
      <Text style={styles.content}>
        {desc}
      </Text>
    </View>
  </View>
)

export default FormHeader

